import React, { useCallback } from 'react'
import classNames from 'classnames'
import { IDeal } from '@/types'

import { useData } from '../useData'
import DealForm from './form'

interface IEditDeal {
  visible: boolean
  onClose: () => void
  node?: Partial<IDeal>
}

const EditDeal: React.FC<IEditDeal> = ({ visible, onClose, node }) => {
  const { loading, submitting, onSubmit } = useData({ id: node?.id })

  const onSubmitForm = useCallback(
    (d: IDeal) => {
      onSubmit(`deals/deals/${node?.id}/`, true)(d)
      onClose()
    },
    [node?.id, onSubmit],
  )

  return (
    <div
      className={classNames('info-box mobile-modal scroll-sticky w-100', {
        open: visible,
      })}
    >
      <DealForm
        loading={loading}
        isEditing={visible}
        initialData={node}
        onCancel={onClose}
        submitting={submitting}
        onSubmit={onSubmitForm}
      />
    </div>
  )
}

export default EditDeal
